import React from "react"

import Link from "../../utils/link"

const FirstCardSection = (props) => { 
  return (
    <div className="first-card-section">
      {props.roomsTop.map((item, index) => {
        return (
          <Link to={`/room/${item.slug}`} className="first-card-section__img" style={{ backgroundImage: `url(${item.acf.card.image.localFile.childImageSharp.fluid.src})` }} key={index}>
            <div className="card-image__heading">{item.acf.card.title}</div>
            <div className="card-image__sub-heading">{item.acf.card.bedrooms} {item.acf.card.bedrooms > 1 ? 'Bedrooms' : 'Bedroom'}</div>
            <div className="card-image__sub-text">Sleeps {item.acf.card.sleeps}</div>
          </Link>
        )
      })}
    </div>
  )
}

export default FirstCardSection
